<template>
  <vs-popup
    class="holamundo"
    title="Finalizar processo de pré abertura"
    :active="true"
    @close="closeModal"
  >
    <div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for class="vs-input--label"
            >Existe pendências no processo de pré abertura?</label
          >
          <vs-switch v-model="form.pendenciaPreAbertura" color="success">
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label for class="vs-input--label">Data de Consulta a pátios</label>
          <div class="inputData">
            <flat-pickr
              :config="configdateTimePicker"
              v-model="form.dataConsultaPatios"
              placeholder="DD/MM/YYYY HH:MM"
              name="Data de Consulta a pátios"
            />
          </div>
        </div>
      </div>
      <div class="vx-row mt-3">
        <div class="vx-col w-full text-right">
          <form role="form" @submit.stop.prevent="onSubmit">
            <BotaoSubmit
              variant="success"
              text="Concluir Finalização"
              :edit="true"
              :aguarde="false"
            ></BotaoSubmit>
          </form>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import BotaoSubmit from "../../../components/BotaoSubmit";


export default {
  props: ["dadosEvento", "formulario"],
  watch: {
    dadosEvento() {
      this.preencheForm();
    },
  },
  components: {
    flatPickr,
    BotaoSubmit,
  },
  data() {
    return {
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d/m/Y H:i",
        locale: Portuguese,
        time_24hr: true,
      },
      form: {
        pendenciaPreAbertura: null,
        dataConsultaPatios: null,
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.formulario.preAberturaAssociado.idEvento) {
        this.form = this.formulario.preAberturaAssociado;
      } else if (this.dadosEvento.idEvento) {
        this.form = {
          ...this.form,
          idEvento: this.dadosEvento.idEvento,
        };
      }
    },
    onSubmit() {
      this.$emit("confimed", this.form);
    },
    closeModal() {
      this.$emit("close", this.form);
    },
  },
  mounted() {
    this.preencheForm();
  },
};
</script>
<style >
.vdp-datepicker input {
  width: 100%;
}
input.flatpickr-input {
  width: 100%;
}

.vx-row.divider {
  border: 0.5px solid rgba(0, 0, 0, 0.08);
}
</style>

